var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSwitchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13L8 17L12 21",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0622 6.5C16.6766 7.56413 17 8.77124 17 10C17 11.2288 16.6766 12.4359 16.0622 13.5C15.4478 14.5641 14.5641 15.4478 13.5 16.0622C12.4359 16.6766 11.2288 17 10 17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7L12 3L8 -1",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93782 13.5C3.32344 12.4359 3 11.2288 3 10C3 8.77124 3.32344 7.56413 3.93782 6.5C4.5522 5.43587 5.43587 4.5522 6.5 3.93782C7.56413 3.32344 8.77124 3 10 3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSwitchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/switch-icon.ad5f0953f22a5c65a79af96f6326470c.svg";